import { useNavigate } from 'react-router-dom'
import { ShoppingBag, ChevronRight } from 'lucide-react'
import { useHouseholdId } from '../../hooks/useHouseholdId'
import { usePendingUnpack } from '../../hooks/usePendingUnpack'

// Conditional Home banner — appears ABOVE the persistent ScanReceiptButton
// only when usePendingUnpack reports a planned trip whose unpack is still in
// progress. Visually subordinate to the scan button (smaller, lighter
// chroma) so the scan path stays the primary action; the banner is just a
// reminder to resume what's already started. Hidden once unpacked_at is set.
export function PendingUnpackBanner() {
  const navigate    = useNavigate()
  const householdId = useHouseholdId()
  const { pending, loading } = usePendingUnpack(householdId)

  if (loading || !pending || !householdId) return null

  return (
    <button
      type="button"
      onClick={() => navigate('/unpack')}
      className="w-full bg-ok-bg/40 border border-forest/30 rounded-2xl px-4 py-3 mb-3 flex items-center justify-between gap-3 text-left transition-colors hover:bg-ok-bg/60"
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <ShoppingBag className="h-4 w-4 text-forest flex-shrink-0" strokeWidth={2} />
        <div className="min-w-0">
          <p className="text-[12px] text-ink leading-[1.3]">
            <span className="font-medium">Welcome back.</span>{' '}
            <span className="text-ink-muted italic font-serif">
              Finish unpacking — {pending.itemCount} item{pending.itemCount === 1 ? '' : 's'}.
            </span>
          </p>
        </div>
      </div>
      <ChevronRight className="h-4 w-4 text-forest flex-shrink-0" strokeWidth={2} />
    </button>
  )
}
